var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3.5,
  y: 33.5,
  width: 38,
  height: 6,
  rx: 1.2,
  fill: "#c8925a"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.5,
  y: 36.1,
  width: 38,
  height: 0.9,
  fill: "#a9713d"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 33.5,
  width: 1,
  height: 2.6,
  fill: "#a9713d"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 33.5,
  width: 1,
  height: 2.6,
  fill: "#a9713d"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 20.5,
  y: 37,
  width: 1,
  height: 2.5,
  fill: "#a9713d"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 36,
  y: 37,
  width: 1,
  height: 2.5,
  fill: "#a9713d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m7.5 8h9.5c0.6 0 1 0.4 1 1v24.5h-11.5v-24.5c0-0.6 0.4-1 1-1z",
  fill: "#c7d3dc"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 9.5,
  width: 8.5,
  height: 24,
  fill: "#5a7d9a"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 11.5,
  width: 5.5,
  height: 8,
  rx: 0.8,
  fill: "#6e91ad"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.1,
  cy: 22.5,
  r: 0.95,
  fill: "#3f4a54"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 23.5,
  y: 8,
  width: 17,
  height: 17,
  rx: 1.2,
  fill: "#7a6a55"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 9.5,
  width: 14,
  height: 14,
  fill: "#cfe6f2"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 11.2,
  width: 14,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 13.3,
  width: 14,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 15.4,
  width: 14,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 17.5,
  width: 14,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  y: 19.6,
  width: 14,
  height: 1.8,
  fill: "#d9c9a8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m37.3 21.4v1.6",
  fill: "none",
  stroke: "#7a6a55",
  strokeWidth: 0.8
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.3,
  cy: 23.5,
  r: 0.7,
  fill: "#7a6a55"
});

function SvgFloorsDoorsShades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorsDoorsShades);
export default __webpack_public_path__ + "static/media/floors-doors-shades.d81d2a6be097b765778a402880f036d6.svg";
export { ForwardRef as ReactComponent };